export default __webpack_public_path__ + "static/media/SCSS-standards-example.0eda1f5b.png";